<template>
	<div class="clearfix">
		<input
			:id="action+name"
			type="checkbox"
			class="check_input"
			:checked="switch_checked"
			@change="handleSelect"
			:disabled="switch_disabled"
		/>

		<label class="checkbox" :for="action+name"></label>
		<label class="check-label" :for="action+name" v-html="label"></label>
	</div>
</template>
<script>
export default {
	name: "CheckBox",
	model: {
		prop: "checked",
		event: "change"
	},
	props: {
		checked: Boolean,
		label: {
			type: String,
			default: ""
		},
		name: {
			type: String,
			default: ""
		},
		action: {
			type: String,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			switch_checked: this.checked,
			switch_disabled: this.disabled,
		};
	},
	methods: {
		handleSelect(event) {
			this.$emit("change", event.target.checked);
		},
	},
	watch: {
		checked() {
			this.switch_checked = this.checked;
			this.$emit("change", this.switch_checked);
		},
		disabled() {
			this.switch_disabled = this.disabled;
		}
	}
};
</script>

<style lang="less"></style>